// frontend/src/AddProduct.js
import React, { useState } from "react";
import "./Admin.css";
import api from "./api/client"; // axios instance that injects admin token

const AddProduct = () => {
  const [name, setName] = useState("");
  const [category, setCategory] = useState("accessory");
  const [productType, setProductType] = useState("accessory");
  const [description, setDescription] = useState("");
  const [price, setPrice] = useState("");
  const [image, setImage] = useState(null);
  const [videoUrl, setVideoUrl] = useState("");

  // ✅ New fields
  const [stockQty, setStockQty] = useState(0);
  const [shippingTN, setShippingTN] = useState("250");
  const [shippingIndia, setShippingIndia] = useState("120");

  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!name || !category || !description || !price || (!image && !videoUrl)) {
      setMessage("Please provide all required fields and either an image or video URL.");
      return;
    }

    try {
      const formData = new FormData();
      formData.append("name", name);
      formData.append("category", category);
      formData.append("productType", productType);
      formData.append("shippingScope", productType === "live-fish" ? "tamil-nadu" : "india");
      formData.append("description", description);
      formData.append("price", price);
      if (image) formData.append("image", image);
      if (videoUrl) formData.append("videoUrl", videoUrl);

      // ✅ Add inventory + shipping
      formData.append("stockQty", stockQty);
      const shippingRates =
        productType === "live-fish"
          ? { TN: shippingTN || 250 }
          : { INDIA: shippingIndia || 120 };
      formData.append("shippingRates", JSON.stringify(shippingRates));

      // Use axios client (adds Authorization: Bearer <admin-token>)
      const response = await api.post("/api/items", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      if (response.status >= 400) {
        const ct =
          response.headers?.["content-type"] || response.headers?.get?.("content-type");
        if (ct && ct.includes("application/json")) {
          const error = response.data;
          throw new Error(error?.message || error?.error || "Failed to upload");
        }
        throw new Error("Failed to upload");
      }

      setMessage("✅ Item uploaded successfully!");
      setName("");
      setCategory("accessory");
      setProductType("accessory");
      setDescription("");
      setPrice("");
      setImage(null);
      setVideoUrl("");
      setStockQty(0);
      setShippingTN("250");
      setShippingIndia("120");
    } catch (error) {
      setMessage(`❌ ${error?.message || "Unexpected error occurred"}`);
    }
  };

  return (
    <div className="admin-container">
      <h2>Add Product or Livestock</h2>

      <form onSubmit={handleSubmit} className="admin-form">
        <div>
          <label>Name:</label>
          <input type="text" value={name} onChange={(e) => setName(e.target.value)} required />
        </div>

        <div>
          <label>Product Type:</label>
          <select
            value={productType}
            onChange={(e) => {
              const nextType = e.target.value;
              setProductType(nextType);
              setCategory(nextType === "live-fish" ? "livestock" : "accessory");
            }}
            required
          >
            <option value="accessory">Accessory</option>
            <option value="live-fish">Live Fish</option>
          </select>
        </div>

        <div>
          <label>Description:</label>
          <textarea
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <div>
          <label>Price (INR):</label>
          <input
            type="number"
            value={price}
            onChange={(e) => setPrice(e.target.value)}
            min="0"
            step="1"
            required
          />
        </div>

        {/* ✅ New: Inventory */}
        <div>
          <label>Stock Quantity:</label>
          <input
            type="number"
            min="0"
            value={stockQty}
            onChange={(e) => setStockQty(e.target.value)}
          />
        </div>

        {/* ✅ New: Shipping by region */}
        <fieldset
          style={{ border: "1px solid #ddd", padding: 12, borderRadius: 6, marginBottom: 16 }}
        >
          <legend>Shipping (INR)</legend>
          <div
            style={{
              display: "grid",
              gridTemplateColumns: "repeat(1, minmax(160px, 1fr))",
              gap: 12,
            }}
          >
            {productType === "live-fish" ? (
              <label>
                Tamil Nadu delivery:
                <input
                  type="number"
                  min="0"
                  value={shippingTN}
                  onChange={(e) => setShippingTN(e.target.value)}
                />
              </label>
            ) : (
              <label>
                All India shipping:
                <input
                  type="number"
                  min="0"
                  value={shippingIndia}
                  onChange={(e) => setShippingIndia(e.target.value)}
                />
              </label>
            )}
          </div>
        </fieldset>

        <div>
          <label>Image (optional):</label>
          <input type="file" accept="image/*" onChange={(e) => setImage(e.target.files[0])} />
        </div>

        <div>
          <label>YouTube Video URL (optional):</label>
          <input
            type="url"
            value={videoUrl}
            onChange={(e) => setVideoUrl(e.target.value)}
            placeholder="https://www.youtube.com/watch?v=..."
          />
        </div>

        <button type="submit">Upload</button>
      </form>

      {message && (
        <p className={message.includes("✅") ? "success-message" : "error-message"}>{message}</p>
      )}
    </div>
  );
};

export default AddProduct;
